import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocalStorage } from './useLocalStorage';

// import { systemActions } from '../containers/System';
import { toggleTheme } from '../containers/System/systemSlice';

const StoredConfigContext = createContext();

const defaultConfig = {
	theme: 'light'
};

// TODO: This still needs work.
// No way to only have preferences for authed users.
const StoredConfigContextProvider = (props) => {
	const { children } = props;
	const theme = useSelector((state) => state.systemSlice.theme);
	const { isAuthed } = useSelector((state) => state.authSlice);
	const dispatch = useDispatch();
	const [userPreferences, setUserPreferences] =
		useLocalStorage('userPreferences');

	useEffect(() => {
		if (userPreferences) {
			for (const [key, value] of Object.entries(userPreferences)) {
				if (isAuthed) {
					if (key === 'theme' && theme !== value) {
						dispatch(toggleTheme());
					}
				}
			}
		}
	}, [isAuthed, userPreferences]);

	const store = (key, value) => {
		const newPreference = Object.assign({}, userPreferences);
		newPreference[key] = value;

		setUserPreferences(newPreference);
	};

	const retrieve = (key) => {
		if (!userPreferences) {
			return defaultConfig[key];
		}

		return userPreferences[key];
	};

	const value = useMemo(
		() => ({
			store,
			retrieve
		}),
		[store, retrieve]
	);

	return (
		<StoredConfigContext.Provider value={value}>
			{children}
		</StoredConfigContext.Provider>
	);
};

StoredConfigContextProvider.propTypes = {
	children: PropTypes.object,
	isAuthed: PropTypes.bool
};

export const StoredConfigProvider = StoredConfigContextProvider;

export const useStoredConfig = () => {
	return useContext(StoredConfigContext);
};
